import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { breakpoints, colors, fluidTypeScale } = useTheme();

  return {
    title: css`
      font-family: 'FS Dillon Bold' !important;
      margin-bottom: 0.625rem;
      display: inine-block;
      line-height: 1.625rem;
      font-weight: 700;
      color: #011e41;
      // font-size: ${fluidTypeScale.font25_9_and_35_54} !important; // this needs to be discuss with client due to some differences in clamp size
      font-size: 1.61875rem !important;
      ${breakpoints.l} {
        line-height: 2.5rem;
        font-weight: 700;
        color: #011e41;
        // font-size: ${fluidTypeScale.font25_9_and_35_54} !important; // this needs to be discuss with client due to some differences in clamp size
        font-size: 2.22125rem !important;
      }
    `,
    link: css`
      display: flex;
      align-items: center;
      color: ${colors.next_grey};
      font-weight: 400;

      &:focus {
        outline: 0;
        text-decoration: underline;
        color: ${colors.next_grey};
        svg {
          color: ${colors.next_grey};
        }
      }
      &:hover {
        font-weight: bold;
      }
      ${breakpoints.s} {
        &:focus-visible {
          outline: none;
          color: ${colors.border_black};
          text-decoration: none;
          border-bottom: 2px solid ${colors.border_black};
          background-color: ${colors.skip_yellow};
        }
        &:focus-visible:hover {
          text-decoration: underline;
          text-decoration-color: ${colors.border_black};
        }
      }
    `,
    contactDetailsCont: css`
      margin-top: -7px;
    `,
  };
};
